import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { halfNameMarkReportSchema } from "../halfNameMarkReportSchema";
import { HalfNameMarkReportTableContent } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'HALFNAMEMARKREPORT'

export function HalfNameMarkReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: ""
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: ""
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(halfNameMarkReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["employeeName", "registrationNumber", "cardNumber", "totalWeight", "reason", "lastWeighTime"]

    const csvHeaders = [
        { label: "Employee Name", value: "employeeName" },
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Card Number", value: "cardNumber" },
        { label: "Total Weight (Kg)", value: "totalWeight" },
        { label: "Reason", value: "reason" },
        { label: "Last Weigh Time", value: "lastWeighTime" },
    ];

    const [data, setdata] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        createDataTable();
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
        getCollectionPointsForDropDown();
        resetDropDowns(DropdownChanges.operationEntity);
    }, [searchData.operationEntityID])

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable({
            "order": [[0, "asc"]]
        });
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWHALFNAMEMARKREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, halfNameMarkReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let result = await service.getReportData(searchData.groupID, searchData.operationEntityID, searchData.collectionPointID);

        result.data.forEach(x => {
            x.lastWeighTime = x.lastWeighTime.split('T')[1];
        });

        destroyDataTable();
        setdata(result.data);
        setIsTableHide();
        createDataTable();
        setButtonHide(false);
        const comleteData = [...result.data,];

        getSelectedDropdownValuesForReport(searchData);

        setCsvData(comleteData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Half Name Mark Report',
            fileName: 'HalfNameMarkReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID]
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Half Name Mark Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>
                            <div className="form-group row">
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="example" className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Employee Name</th>
                                                        <th>Registration Number</th>
                                                        <th>Card Number</th>
                                                        <th>Total Weight (Kg)</th>
                                                        <th>Reason</th>
                                                        <th>Last Weigh Time</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <HalfNameMarkReportTableContent
                                                        data={data}
                                                        contentRowNames={contentRowNames}


                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {isTableHide ? null :
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Half Name Mark Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"

                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={contentRowNames} data={data}
                                 initialData={searchData}
                                />
                            </div>
                            <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Excel"
                                onClick={createFile}
                            />

                        </div>
                    }
                </div>
            </div>
        </Fragment >
    );
}



